var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import Header from './Header';
import Details from './Details';
import Note from './Note';
import triggerChangePaymentDueDateAnalytics from '../../helpers/trigger-change-payment-due-date-analytics';
import { PAGE_NAME } from '../../const/analytics';
var Successful = function (_a) {
    var currentDueDay = _a.currentDueDay, selectedDay = _a.selectedDay, _b = _a.isPromoExtended, isPromoExtended = _b === void 0 ? false : _b;
    useEffect(function () {
        triggerChangePaymentDueDateAnalytics(__assign({ pageName: PAGE_NAME.COMPLETE }, (isPromoExtended && {
            message: 'the expiration date of your existing promotion has changed'
        })));
    }, [isPromoExtended]);
    return (_jsxs("div", __assign({ "data-testid": "successful-screen" }, { children: [_jsx(Header, { isPromoExtended: isPromoExtended }), _jsx(Details, { currentDueDay: currentDueDay, selectedDay: selectedDay }), _jsx(Note, {})] })));
};
export default Successful;
